import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { FinantialReportService } from "src/app/shared/services/finantial-report.service";
import { finantialReportActions } from "./finantial-report.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class FinantialReportEffects {

    constructor(
        private service: FinantialReportService,
        private action$: Actions,
        private notify: NotifyService
    ) { }

    /*
    loadFinantialReport$ = createEffect(() =>
        this.action$.pipe(
            ofType(finantialReportActions.loadFinantialReport),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res) => finantialReportActions.loadFinantialReportSuccess({ finantial_report: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )
            )
        )
    )*/

}